import React from 'react';
import { Typography, Container } from '@mui/material';
import ToolHeader from './ToolHeader';

export default function PrivacyPolicy() {
    return (
        <Container
            maxWidth="lg"
            sx={{
                pt: 20,
                pb: 4
            }}
        >
            <ToolHeader title="Privacy Policy" />
            <Typography variant="h6" component="h1" gutterBottom>
                Privacy Policy
            </Typography>

            <Typography variant="body1" gutterBottom>
                Last updated: 12-Jan-2025
            </Typography>

            <Typography variant="body1" paragraph>
                TextSimpler ("us", "we", or "our")  is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website textsimpler.com (the "Website"). Please read this Privacy Policy carefully. By using the Website, you agree to the terms described herein.            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Information We Collect
            </Typography>

            <Typography variant="body1" paragraph>
                We may collect personal information such as your name, email address, phone number, and input data submitted for analysis in our tools. This information is collected to provide and improve the Services. Additionally, log data, including your IP address, browser type, and pages visited, is used to improve our Services and may be analyzed using tools such as Google Analytics.
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                How We Use Your Information
            </Typography>

            <Typography variant="body1" paragraph>
                We use the information we collect to, Provide and maintain the Website, Personalize your experience, Respond to your inquiries, Process transactions, Improve the Website’s functionality
                Comply with legal obligations
            </Typography>


            <Typography variant="h6" component="h2" gutterBottom>
                Cookies and Tracking Technologies
            </Typography>

            <Typography variant="body1" paragraph>
                We may use cookies, web beacons, and other tracking technologies to collect information about your interaction with the Website. You can control cookies through your browser settings.
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Data Sharing
            </Typography>

            <Typography variant="body1" paragraph>
                We do not sell your data. Limited sharing occurs with service providers for functionality (e.g., Hugging Face API) or to comply with legal requirements.
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Data Security
            </Typography>

            <Typography variant="body1" paragraph>
                We use administrative, technical, and physical security measures to protect your information. However, no method of transmission over the Internet or electronic storage is 100% secure, and we cannot guarantee absolute security.            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Your Rights
            </Typography>

            <Typography variant="body1" paragraph>
                Depending on your location, you may have certain rights regarding your personal information, including:
                Accessing your data, Updating or correcting your data, Deleting your data, Withdrawing consent

                To exercise these rights, please contact us at contact@textsimpler.com.
            </Typography>



            <Typography variant="h6" component="h2" gutterBottom>
                Children's Privacy
            </Typography>

            <Typography variant="body1" paragraph>
                Our Services are intended for users aged 18 and older. We do not knowingly collect data from children under 13.
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Changes to This Privacy Policy
            </Typography>

            <Typography variant="body1" paragraph>
                We may update this Privacy Policy periodically. Changes are effective immediately upon posting.
            </Typography>

            <Typography variant="h6" component="h2" gutterBottom>
                Contact Us
            </Typography>

            <Typography variant="body1" paragraph>
                If you have any questions, please contact us.
            </Typography>

        </Container>
    );
}
